<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="cycle_id" :name="lodash.upperFirst($t('jala_harvests.cycle'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.cycle')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <jala-cycle-select-ajax
          name="cycle_id"
          v-model.number="model.cycle_id"
          :disabled="!!model.id"
        ></jala-cycle-select-ajax>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="harvested_at" :name="lodash.upperFirst($t('jala_harvests.harvested_at'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.harvested_at')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <date-picker
            name="date"
            type="date"
            format="DD MMMM YYYY"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.harvested_at"
        >
        </date-picker>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="weight" :name="lodash.upperFirst($t('jala_harvests.weight'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.weight')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="weight"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.weight"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="size" :name="lodash.upperFirst($t('jala_harvests.size'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.size')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="size"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.size"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="selling_price" :name="lodash.upperFirst($t('jala_harvests.selling_price'))" rules="required|double" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.selling_price')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <numeral-input
            name="selling_price"
            required
            :state="errors[0] ? false : (validated ? true : null)"
            v-model.number="model.selling_price"
        ></numeral-input>
      </b-form-group>
    </validation-provider>
    <validation-provider vid="status" :name="lodash.upperFirst($t('jala_harvests.status'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_harvests.status'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <multiselect
            name="status"
            :value="selects.statuses.find((v) => (v.id === model.status))"
            @input="(v) => { model.status = (v || {}).id }"
            label="label"
            :options="selects.statuses">
        </multiselect>
      </b-form-group>
    </validation-provider>
    <hr>
    <validation-provider vid="remark" :name="lodash.upperFirst($t('jala_farms.remark'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
        class="row mb-3"
        :label="lodash.upperFirst($t('jala_farms.remark'))"
        :state="errors[0] ? false : (validated ? true : null)"
        :invalid-feedback="errors[0]"
      >
        <editor
          ref="editor"
          v-if="$parent.$parent.$options.name !== 'BModal'"
          class="form-control"
          :init="editorInit"
          inline
          plugins="lists link image paste help wordcount"
          toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
          v-model="model.remark"
        />
        <b-form-textarea v-else v-model="model.remark" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import JalaCycleSelectAjax from "../inputs/jala-cycle-select-ajax";

  export default {
    components: {
      JalaCycleSelectAjax
    },
    extends: FormModel,
    data() {
      return {
        model: {
          cycle_id: this.$route.query.cycle_id,
          started_at: this.$moment().format('YYYY-MM-DD'),
          feeding_tray_count: 4,
          selling_price: 0,
          ...this.value,
        },
        selects: {
          statuses: [
            { id: 'Partial', label: this.lodash.upperFirst(this.$t('jala_harvests.partial')) },
            { id: 'Full', label: this.lodash.upperFirst(this.$t('jala_harvests.full')) },
            { id: 'Failed', label: this.lodash.upperFirst(this.$t('jala_harvests.failed')) },
          ]
        }
      }
    },
    mounted() {
      //
    }
  }
</script>
